import apiClient from './api.client';

const AuthService = {
  signin: async (email, password) => {
    const res = await apiClient.post('/auth/signin', { email, password });
    return res.data; // { accessToken, user }
  },
};

export default AuthService;
